import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { RouteComponentProps } from 'react-router';
import { AncillarySuppliersImporterContainer } from './importer';

export interface AncillarySuppliersRoutingProps extends RouteComponentProps {}

export const AncillarySuppliersRouting = (props: AncillarySuppliersRoutingProps) => {
  return (
    <Switch>
      <Route path={[`${props.match.path}/`, `${props.match.path}`]} component={AncillarySuppliersImporterContainer} />
    </Switch>
  );
};

export const RateBreakRouting = compose(withRouter)(AncillarySuppliersRouting);
